enum AwsRumDomain {
    Gamma = 'gamma',
    Prod = 'prod',
}
export default AwsRumDomain;